import React from "react";
import Select from "react-select";
import { MdErrorOutline } from "react-icons/md";

const MultiSelectDropdown = ({
  title,
  name,
  placeholder,
  errors,
  touched,
  requiredField,
  options,
  values,
  displayLabel,
  idLabel,
  setFieldValue,
  setFieldTouched,
}) => {
  const formattedOptions = options.map((option) => ({
    label: option[displayLabel],
    value: option[idLabel],
  }));

  const selectShadow =
    errors?.[name] && touched?.[name]
      ? "inset 0 0 0 1px rgb(220 38 38)"
      : "inset 0 0 0 1px rgb(229 231 235)";

  const selectShadowFocused =
    errors?.[name] && touched?.[name]
      ? "inset 0 0 0 1px rgb(220 38 38)"
      : "inset 0 0 0 1px rgb(71, 127, 245)";

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      borderRadius: "0.375rem",
      border: "none",
      boxShadow: state.isFocused ? selectShadowFocused : selectShadow,
      fontSize: "0.875rem",
      lineHeight: "1.5",
      cursor: "text",
      padding: "2px 8px",
    }),
  };

  return (
    <div className="">
      <div className="mb-2">
        <label className="text-gray-500">
          {title} {requiredField && <span style={{ color: "red" }}>*</span>}
        </label>
      </div>
      <Select
        isMulti={true}
        options={formattedOptions}
        value={formattedOptions.filter((option) =>
          values.includes(option.value)
        )}
        styles={selectStyles}
        onChange={(selected) =>
          setFieldValue(
            name,
            selected.map((option) => option.value)
          )
        }
        onBlur={() => setFieldTouched(name, true)}
        placeholder={placeholder}
      />
      {errors[name] && touched[name] && (
        <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
          <MdErrorOutline size={16} />
          <p className="text-xs">{errors[name]}</p>
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
